/*
     * @description Enum identifying assets in the protocol. Corresponds to the string of the asset's symbol.
     *
     */
export enum AssetType {
    XTZ = "XTZ",
    FA12 = "FA12",
    FA2 = "FA2",
    ETH = "ETH",
    USD = "USD",
    BTC = "BTC",
    WTZ = "WTZ",
    OXTZ = "OXTZ",
    USDT = "USDT",
    TZBTC = "TZBTC",
    STXTZ = "STXTZ"
}

export enum TokenStandard {
    XTZ = 0,
    FA12,
    FA2,
    FA12_PACKED,
}
